import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const breastCyst: AnswerPathTreeNode = {
  path: 'breastCyst',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredBreastCystDetails }],
};
